



























































    import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
    @Component(
        {
            components:{
            }
        }
    )
    export default class intro extends Vue {
        async mounted () {
        
        }
 
        
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/intro.vue